/**
 * User view
 */
import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { Page, BlockStack, Tabs } from '@shopify/polaris';

import { useParams, useLocation } from 'react-router-dom';
import UserLoginHistory from './user_detail/user.login.history';

import SkeletonLoading from 'components/skeletonPageLoading';
import UserGeneralInformation from './user_detail/user.general.information';
import UserEditInformation from './user_detail/user.edit';
import ChangeUserPassword from './user_detail/users.password';
import { TypedUser } from 'interface/user.model';
import __ from 'languages/index';
import { Helmet } from 'react-helmet-async';
import { useGetUserByAdmin } from 'queries/users.query';
import UserTaxInformationList from 'entities/user_tax_information/user_tax_information.list';

export default function UserDetail() {
  let { users_slug } = useParams();

  const { refetch: getEntity, data, isPending: loading } = useGetUserByAdmin(users_slug);

  let { hash } = useLocation();

  const [entity, setEntity] = useState<TypedUser>(null);
  useEffect(() => {
    if (data) setEntity(data);
  }, [data]);

  /**
   * Lấy URL ra... để query. chú ý phải load nội dung mới
   * trong useEffect
   */

  useEffect(() => {
    if (users_slug) getEntity();
  }, [users_slug]);

  const [tabselected, setTabselected] = useState(0);
  const handleTabChange = useCallback((selectedTabIndex: number) => {
    window.location.hash = '#tab-' + selectedTabIndex;
  }, []);

  const tabs = useMemo(
    () => [
      {
        id: 'tab_4',
        content: 'Chỉnh sửa tài khoản',
        panelID: 'edit_user_account',
      },
      {
        id: 'tab_5',
        content: 'Mật khẩu',
        panelID: 'user_password',
      },
      {
        id: 'tab_6',
        content: 'Lịch sử đăng nhập',
        panelID: 'user_login_history',
      },
      {
        id: 'tab_7',
        content: 'Thông tin thuế',
        panelID: 'user_tax_information',
      },
    ],
    []
  );

  useEffect(() => {
    if (hash) {
      let tabb = Number(String(hash || ' ').replace('#tab-', ''));
      if (tabs[tabb] === undefined) tabb = 0;
      setTabselected(tabb);
    } else {
      setTabselected(0);
    }
  }, [hash, tabs]);

  return (
    <>
      <Helmet>
        <title>{entity?.display_name}</title>
      </Helmet>
      {loading ? (
        <SkeletonLoading />
      ) : (
        <Page
          title={'Danh sách người dùng'}
          backAction={{
            content: __('all_users'),
            url: '/users',
          }}
        >
          {entity !== null && (
            <BlockStack gap="400">
              <UserGeneralInformation entity={entity} />
              <div className="custom_tabs" style={{ margin: '0 -15px' }}>
                <Tabs tabs={tabs} selected={tabselected} onSelect={handleTabChange}></Tabs>
                <div style={{ margin: '15px' }}>
                  {tabs[tabselected].panelID === 'edit_user_account' && <UserEditInformation onClose={() => {}} entity={entity} />}
                  {tabs[tabselected].panelID === 'user_password' && <ChangeUserPassword user_data={entity} />}
                  {tabs[tabselected].panelID === 'user_login_history' && <UserLoginHistory user_id={users_slug} />}
                  {tabs[tabselected].panelID === 'user_tax_information' && <UserTaxInformationList user_id={users_slug} />}
                </div>
              </div>
            </BlockStack>
          )}

          <br />
          <br />
          <br />
          <br />
        </Page>
      )}
    </>
  );
}

